import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import AlbumForm from './album-form';

@inject('albumsStore', 'artistStore', 'userStore')
@observer
class AlbumModalContent extends React.Component {
	componentWillMount () {
		const { albumsStore, album } = this.props;
		this.album = _.isObject(album) ? album : albumsStore.newAlbum();
	}

	render () {
		return (
			<div className="modal-contenrt">
				<div className="grid-x grid-padding-x">
					<div className="cell small-12">
						<AlbumForm
							album={ this.album }
							handleImageCrop={ this.handleImageCrop }
						/>
					</div>
				</div>

				<div className="modal-button-group">
					<button
						onClick={ this.props.handleCloseModal }
						className="button clear secondary padding-left-0"
					>
						Close Modal
					</button>

					<button
						className="button clear"
						onClick={ this.onClick }
					>
						Save
					</button>
				</div>
			</div>
		);
	}

	@autobind
	onClick () {
		const { artistStore, userStore } = this.props;
		const artist = artistStore.getArtistByID(this.album.artistID);
		const user = userStore.getItemByID(artist.userID);

		this.album.save({ user, artist });
		this.props.handleCloseModal();
	}

	@autobind
	handleImageCrop (imageData) {
		this.album.imageData = imageData;
	}
}

export default AlbumModalContent;
